import React, { useEffect, useState, useContext } from "react";
import styled from "@emotion/styled";
import { NavItem } from "./NavItem";

import hightailGamesLogo from "../../images/hightail-games-logo.png";
import { SMALL_DEVICES } from "../../mediaQueries";

const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;
  z-index: 10;
  background-color: transparent;
  transition: background-color 0.4s;

  &.active {
    background-color: #00000b;
  }

  ${SMALL_DEVICES} {
    position: relative;
    flex-direction: column;
    margin-bottom: 40px;
  }
`;

const Section = styled.div`
  display: flex;
  align-items: center;
  flex: 1;

  &.center {
    justify-content: center;
  }

  &.end {
    justify-content: flex-end;
  }
`;

const Logo = styled.img`
  width: 200px;
  height: 100px;
  object-fit: contain;
  margin: 20px;
`;

const ItemSpacing = styled.div`
  margin: 0 60px;

  ${SMALL_DEVICES} {
    margin: 0 4vw;
  }
`;

export const NavHeader: React.FC = (props) => {
  const [navBackgroundActive, setNavBackgroundActive] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  function handleScroll() {
    if (!navBackgroundActive && window.pageYOffset >= 100) {
      setNavBackgroundActive(true);
      return;
    }

    if (navBackgroundActive && window.pageYOffset < 100) {
      setNavBackgroundActive(false);
      return;
    }
  }

  return (
    <Container className={navBackgroundActive ? "active" : ""}>
      <Section>
        <Logo src={hightailGamesLogo} />
      </Section>
      <Section className="end">
        <ItemSpacing>
          <NavItem label="Home" path={"/"} />
        </ItemSpacing>
        <ItemSpacing>
          <NavItem label="Games" path={"/games"} />
        </ItemSpacing>
        <ItemSpacing>
          <NavItem label="Devlogs" path={"/devlogs"} />
        </ItemSpacing>
        <ItemSpacing>
          <NavItem label="Team" path={"/team"} />
        </ItemSpacing>
        {/* <ItemSpacing>
          <NavItem label="Contact" path={"/contact"} />
        </ItemSpacing> */}
      </Section>
    </Container>
  );
};
